import moment, { Moment } from 'moment';
import { MomentizeRangePickerData, MomentString } from '@models/types';

export const formatData = <T>(
  data: T,
  item: keyof T,
  revert?: boolean,
): MomentString => (revert ? moment(data[item]).format() : moment(data[item]));

const canBeMomentize = (date: Moment, revert?: boolean): boolean =>
  revert ? date && moment.isMoment(date) && date.isValid() : !!date;

export const momentizeObjectDates = <T>(
  data: T,
  fields: Array<keyof T>,
  revert?: boolean,
  revertWithNulls?: boolean,
): T => ({
  ...data,
  ...fields.reduce((acc: Record<string, MomentString>, field: keyof T) => {
    const emptyItem = revertWithNulls ? { [field]: null } : {};

    return {
      ...acc,
      ...(data?.[field] &&
      canBeMomentize(data[field] as unknown as Moment, revert)
        ? { [field]: formatData<T>(data, field, revert) }
        : emptyItem),
    };
  }, {}),
});

export const momentizeRangePickerValues = <T extends Record<string, any>>(
  data: T,
  fields: Array<keyof T>,
  revert?: boolean,
  revertWithNulls?: boolean,
): T & MomentizeRangePickerData => ({
  ...data,
  ...fields.reduce(
    (acc: MomentizeRangePickerData, field: keyof T) => ({
      ...acc,
      ...{
        [field]: momentizeObjectDates(
          data[field],
          ['from', 'to'],
          revert,
          revertWithNulls,
        ),
      },
    }),
    {},
  ),
});
